import { useQuery } from '@tanstack/react-query';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';
import { QUERY_KEYS } from '@/utils/query-keys';
import { validateUuid } from '@/utils/validate-uuid';

interface GetPreventiveMeasureParams {
	organization_id: string;
	company_id: string;
	report_id: string;
	review_id: string;
}

const Service = Resolution886ReportService.getInstance();

export function useGetPreventiveMeasure(params: GetPreventiveMeasureParams) {
	const isEnabled = validateUuid([params.organization_id, params.company_id, params.report_id, params.review_id]);

	return useQuery({
		queryKey: [QUERY_KEYS.GET_PREVENTIVE_MEASURE, params],
		queryFn: async () => Service.getPreventiveMeasure(params),
		enabled: isEnabled
	});
}
